import { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import Input from "../../../../components/elements/form/Input";
import ButtonAction from "../../../elements/buttons/ButtonAction";
import Paragraph from "../../../elements/p/Paragraph";
import H3 from "../../../elements/titles/H3";
import InputFile from "../../../elements/form/InputFile";
import InputSelect from "../../../elements/form/InputSelect";
import { uploadImage } from "../../../../api/utils";
import categoriesContext from "../../../../dataManager/context/categoriesContext";
import { getDocumentRef } from "../../../../api/utils";
import { createProduct } from "../../../../api/products/productsApi";
import { checkFiels } from "../../../../functions/functions";
import { percentageReduction } from "../../../../functions/functions";
const initProductData = {
  name: "",
  caracteristics: "",
  description: "",
  prise: "",
  oldPrise: "",
  image: null,
  categoryMembership: "",
};

const AddProduct = () => {
  //context variables
  const { categories, getOneCategory } = useContext(categoriesContext);

  //state variables
  const [productData, setProductData] = useState(initProductData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  //firebase state variables
  const [imageUrl, setImageUrl] = useState("");
  const [progressLoadingImage, setProgressLoadingImage] = useState(0);
  const [isLoadingImage, setIsLoadingImage] = useState(false);

  //useEffect section
  useEffect(() => {
    if (imageUrl) {
      addProduct({ ...productData, image: imageUrl });
    }
  }, [imageUrl]);

  //some handler
  const handleChange = (e, inputTarget) => {
    setError("");
    switch (inputTarget) {
      case "name":
        return setProductData({ ...productData, name: e.target.value });
      case "caracteristics":
        return setProductData({
          ...productData,
          caracteristics: e.target.value,
        });
      case "description":
        return setProductData({ ...productData, description: e.target.value });
      case "prise":
        return setProductData({ ...productData, prise: e.target.value });
      case "oldPrise":
        return setProductData({ ...productData, oldPrise: e.target.value });
      case "image":
        return setProductData({ ...productData, image: e.target.files[0] });
      case "categoryMembership":
        return setProductData({
          ...productData,
          categoryMembership: e.target.value,
        });
      default:
        return;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    //check if all fields are filled
    const allFieldsFilled = checkFiels(productData);
    if (!allFieldsFilled) {
      return setError(
        "Remplissez tous les champs pour ajouter ce nouveau produit !"
      );
    }

    //start loading
    setLoading(true);

    //add the category name after the product name
    const categoryName = getOneCategory(productData.categoryMembership).getName;
    setProductData((prevState) => ({
      ...productData,
      name: prevState.name + ` | ${categoryName}`,
    }));

    //start upload image on firebase
    uploadImage(
      "products",
      productData.image,
      setImageUrl,
      setProgressLoadingImage,
      setIsLoadingImage
    );
  };

  //some functions
  async function addProduct(data) {
    //get the ref to the category membership
    const categoryMembershipRef = getDocumentRef(
      "categories",
      data.categoryMembership
    );

    const { data: infoCreation, error } = await createProduct({
      ...data,
      categoryMembership: categoryMembershipRef,
      creationDate: Date.now(),
    });

    if (error || !infoCreation) {
      toast.error("Une erreur est survenue lors de l'ajout du produit", {
        theme: "colored",
      });
      setLoading(false);
      return;
    }

    toast.success("Le produit a été ajouté avec succès", { theme: "colored" });
    setProductData(initProductData);
    setImageUrl("");
    setLoading(false);
  }

  const persentageReductionBox = (
    <Paragraph size="small">
      Pourcentage de réductin{" "}
      {percentageReduction(
        Number(productData.prise),
        Number(productData.oldPrise)
      )}{" "}
      %
    </Paragraph>
  );

  return (
    <>
      <form className="mt-8 md:mt-12" onSubmit={handleSubmit}>
        <H3>Ajouter un nouvel article dans votre boutique</H3>
        <div className="mt-4 flex flex-col space-y-4">
          <InputFile
            labelName="Image de cet article"
            name="image-category"
            onChange={(e) => handleChange(e, "image")}
          />
          <Input
            labelName="Nom article"
            type="text"
            name="name-product"
            placeholder="dell xps 13 orison"
            value={productData.name}
            onChange={(e) => handleChange(e, "name")}
          />
          <InputSelect
            labelName="catégorie consernée"
            options={categories.map((c) => ({
              value: c.getId,
              label: c.getName,
            }))}
            value={productData.categoryMembership}
            onChange={(e) => handleChange(e, "categoryMembership")}
          />
          <Input
            labelName="Caractéristiques"
            type="text"
            name="features-product"
            placeholder="ram: 4gb, cpu: i7, gpu: radeon"
            value={productData.caracteristics}
            onChange={(e) => handleChange(e, "caracteristics")}
          />
          <Input
            labelName="Prix"
            type="number"
            name="prise-product"
            placeholder="250000"
            min={0}
            value={productData.prise}
            onChange={(e) => handleChange(e, "prise")}
          />
          <Input
            labelName="Ancien prix"
            type="number"
            name="oldPrise-product"
            placeholder="380000"
            min={0}
            value={productData.oldPrise}
            onChange={(e) => handleChange(e, "oldPrise")}
          />

          {productData.prise && productData.oldPrise && persentageReductionBox}
          <Input
            labelName="Description"
            type="text"
            name="describe-product"
            placeholder="Cette marque de pc est la plus acheté car en plus de son prix abordable, elle est très moins chère"
            value={productData.description}
            onChange={(e) => handleChange(e, "description")}
          />
        </div>
        <ButtonAction size="small" classe="mt-2" loading={loading}>
          Ajouter l'article
        </ButtonAction>
      </form>
      <span className="font-nunito text-sm text-[#fc3838]">
        {error && error}
      </span>
    </>
  );
};

export default AddProduct;
